import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sms-subject",
  "use": "icon-sms-subject-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-sms-subject\"><defs><style type=\"text/css\"></style></defs><path d=\"M868.8 98.2H157.3c-32.7 0-59.3 26.5-59.3 59.3V869c0 32.7 26.5 59.3 59.3 59.3h711.5c32.7 0 59.3-26.5 59.3-59.3V157.5c0-32.7-26.6-59.3-59.3-59.3z m-18.5 704.1c0 26.6-21.6 48.2-48.2 48.2H224c-26.6 0-48.2-21.6-48.2-48.2V224.2c0-26.6 21.6-48.2 48.2-48.2h578.1c26.6 0 48.2 21.6 48.2 48.2v578.1z\" p-id=\"6520\" /><path d=\"M275.9 631.8h118.6v177.9H275.9zM453.7 631.8h118.6v177.9H453.7zM631.6 631.8h118.6v177.9H631.6zM216.6 216.8h592.9V454H216.6z\" p-id=\"6521\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sms-subject.svg
// module id = 4H1Q
// module chunks = 21